import { common, grey, widget } from 'src/theme/palette';

export const dateLabelStyle = (row, color) => ({
    px: 2,
    backgroundColor: (row || color) ? 'rgba(84, 214, 44, 0.16)' : 'rgba(255, 72, 66, 0.16)',
    color: (row || color) ? common.meadowGreen : common.fireBerry
});
export const statusLabelStyle = (row) => ({
    px: 2,
    backgroundColor: ((row === 'FAILED_TO_ATTEND_CONSULTATION' && 'rgba(255, 72, 66, 0.16)') || (row === 'NEW' && 'rgba(84, 214, 44, 0.16)')) || 'rgba(24, 144, 255, 0.16)',
    color: ((row === 'FAILED_TO_ATTEND_CONSULTATION' && common.fireBerry) || (row === 'NEW' && common.meadowGreen)) || widget.tagBlueColor
});
export const badgeStyle = (row, contactedCount) => ({
    position: 'unset',
    '.MuiBadge-badge': {
        transform: `scale(1) translate(${row === 'CONSULTATION_BOOKED' ? '50%' : '100%'}, '-50%')`,
        display: contactedCount === 0 ? 'none' : '',
        bgcolor: 'primary.darker',
        minWidth: 16,
        height: 16,
        fontSize: '0.65rem',
        padding: '0 4px',
    },
});
export const viewBtnStyle = (row) => ({
    color: `${grey[0]} !important`,
    backgroundColor: 'primary.main !important',
    boxShadow: '0px 8px 16px rgba(51, 102, 255, 0.24)',
    minWidth: row === 'CLOSED' ? '120px' : '172px',
    borderRadius: 1,
    p: '6px 14px',
    fontSize: '0.8125rem',
});
export const archivingButtonStyle = (row) => ({
    backgroundColor: `${row.is_archive_pending ? grey[200] : 'primary.main'} !important`,
    color: 'common.white !important',
    boxShadow: '0px 8px 16px rgba(51, 102, 255, 0.24)',
    minWidth: '150px',
    borderRadius: 1,
    p: '6px 14px',
    fontSize: '0.8125rem',
});
export const arcBtnStyle = (contactedCount) => ({
    position: 'relative',
    '.MuiBadge-badge': {
        transform: 'scale(1) translate(100%, \'-50%\')',
        backgroundColor: 'rgba(145, 158, 171, 0.48)',
        color: grey[0],
        display: contactedCount === 0 ? 'none' : ''
    }
});
export const flwBtnStyle = (row) => ({
    backgroundColor: 'transparent',
    color: `${!row ? 'primary.main' : grey[400]} !important`,
    border: '1px solid',
    borderColor: !row ? 'primary.main' : grey[300],
    boxShadow: !row ? '0px 2px 8px rgba(0, 167, 111, 0.2)' : 'none',
    borderRadius: 1,
    p: '6px 14px',
    fontSize: '0.8125rem',
    minWidth: '150px',
    '&&:hover': {
        backgroundColor: !row ? 'primary.main' : 'transparent',
        color: !row ? `${grey[0]} !important` : `${grey[400]} !important`,
        boxShadow: !row ? '0px 4px 12px rgba(0, 167, 111, 0.24)' : 'none',
        '& .MuiSvgIcon-root': { color: !row ? grey[0] : grey[400] },
        '& .MuiBadge-badge': { bgcolor: !row ? 'rgba(255,255,255,0.3)' : undefined },
    },
});
export const chipStyle = (val) => ({
    borderRadius: '6px',
    color: 'white',
    background: val === 'Yes' ? common.mediumSeaGreen : common.fieryRed,
    fontWeight: 500,
    height: 22,
    fontSize: '0.75rem',
});
export const menuListStyle = {
    boxShadow: '0px 20px 40px -4px rgba(145, 158, 171, 0.16)',
    backgroundColor: grey[0],
    borderRadius: '12px',
    padding: '8px'
};
export const iconBtnStyle = {
    borderRadius: '100px',
    width: '18px',
    height: '18px',
    bgcolor: common.mintyZest,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    margin: 'auto'
};
export const recordAttendedButtonStyle = {
    backgroundColor: 'primary.main !important',
    color: `${grey[0]} !important`,
    border: 'none !important',
    borderRadius: 0,
    p: '6px 14px',
    fontSize: '0.8125rem',
};

export const tableCellStyle = (typed) => ({ whiteSpace: 'nowrap', cursor: typed !== 'ArchiveTable' && 'pointer' });

export const duplicateTableRowStyle = (row) => ({
    cursor: 'pointer', 
    borderBottom: 'solid 1px rgba(0,0,0,0.1)', 
    pointerEvents: row.is_archive_pending ? 'none' : 'visible', 
    bgcolor: row.is_archive_pending && 'rgb(235 235 235)', 
    'td': { 
        bgcolor: row.is_archive_pending && 'rgb(235 235 235)!important' 
    }
});

export const tableMoreMenuBoxStyle = {
    'button': {
        minWidth: 'auto !important',
        whiteSpace: 'normal !important'
    },
    '.MuiButtonGroup-root': {
        minWidth: 'auto !important'
    },
    '.MuiMenuItem-root button svg': {
        mr: 0
    }
};

export const assignMainBoxStyle = {
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center'
};

export const tableCellInnerBoxStyle = {
    width: '100%',
    cursor: 'pointer',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center'
};

export const tableCellRelativeBoxStyle = { ...tableCellInnerBoxStyle, position: 'relative', justifyContent: 'flex-start' };

export const tableStatusTextStyle = {
    fontWeight: 400,
    textAlign: 'center'
};

export const apptMethodSelectStyle = {
    width: '100%',
    height: '100%',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        display: 'none'
    },
    '.MuiSelect-select': {
        textOverflow: 'clip',
        p: 0,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        paddingRight: '0 !important',
    }
};

export const apptMethodLabelStyle = () => ({
    px: 2,
    cursor: 'pointer'
});

export const datePickerBoxStyle = {
    position: 'absolute',
    width: '100%',
    top: '0',
    maxHeight: '100%',
    opacity: 0,
    cursor: 'pointer',
    zIndex: 0
};

export const datePickerTextFieldStyle = {
    position: 'absolute',
    width: '100%',
    left: 0,
    p: '0',
    top: '-15px'
};
export const arrowButtonStyle = (theme) => ({
    backgroundColor: `${theme.palette.primary.main} !important`,
    padding: '0 10px !important',
    minWidth: '28px !important',
    borderRadius: 0,
    border: 'none !important',
    boxShadow: `inset 1px 0 0 0 ${theme.palette.primary.dark}`,
});

export const dateTimeTypoStyle = {
    textAlign: 'left',
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: '18px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    'span': {
        display: 'block',
        color: grey[600],
        fontSize: '0.75rem',
        fontWeight: 400,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    }
};

export const dateOfEnquiryLabelStyle = (formatData, params, currentDate, typed) => {
    const formattedDate = formatData(params?.row?.created_at);
    const isToday = formattedDate === currentDate;

    // Archive table (2026-07-09): the age palette below encodes ACTIVE-lead
    // urgency ("old enquiry = red") — meaningless once a lead is archived,
    // where it painted every date red. Archived rows render neutral, with
    // green only when the lead was ARCHIVED today (quick "actioned today"
    // scan). Scoped by `typed`, so every other table keeps the palette.
    if (typed === 'ArchiveTable') {
        const archivedToday = formatData(params?.row?.archived_at) === currentDate;
        return {
            backgroundColor: 'transparent',
            color: archivedToday ? 'common.lightGreen' : grey[700],
            cursor: false,
            height: 'auto',
            minHeight: '22px',
            p: '1px 0',
            fontSize: '0.8125rem',
            fontWeight: 400,
        };
    }

    let textColor = 'common.red';
    if (isToday) {
        textColor = 'common.lightGreen';
    } else {
        const parts = formattedDate?.split('-');
        const currentParts = currentDate?.split('-');
        if (parts?.length === 3 && currentParts?.length === 3) {
            const enquiryDate = new Date(parts[2], parts[1] - 1, parts[0]);
            const today = new Date(currentParts[2], currentParts[1] - 1, currentParts[0]);
            const diffDays = Math.floor((today - enquiryDate) / (1000 * 60 * 60 * 24));
            if (diffDays <= 1) {
                textColor = grey[700];
            } else if (diffDays <= 7) {
                textColor = '#b45309';
            }
        }
    }

    return {
        backgroundColor: 'transparent',
        color: textColor,
        cursor: typed !== 'ArchiveTable' && 'pointer',
        height: 'auto',
        minHeight: '22px',
        p: '1px 0',
        fontSize: '0.8125rem',
        fontWeight: 400,
    };
};

export const dateOfAppointmentLabelStyle = (row, color, typed) => ({
    px: 2,
    backgroundColor: 'transparent',
    color: (row || color) ? 'common.lightGreen' : 'common.red',
    cursor: typed !== 'ArchiveTable' && 'pointer',
    height: 'auto',
    minHeight: '22px',
    p: '1px 0',
});

export const referralSelectStyle = {
    width: '100%',
    height: '100%',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        display: 'none'
    },
    '.MuiSelect-select': {
        textOverflow: 'clip',
        p: 0,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        display: 'flex',
        paddingRight: '0 !important',
        justifyContent: 'center'
    }
};

export const buttonGroupStyle = (theme) => ({
    boxShadow: '0px 4px 10px rgba(0, 167, 111, 0.24)',
    borderRadius: '8px',
    overflow: 'hidden',
    width: 'fit-content',
    '& .MuiButtonGroup-grouped': {
        border: 'none !important',
        borderRadius: 0,
        margin: '0 !important',
    },
    '& .MuiButtonGroup-grouped:not(:last-of-type)': {
        borderRight: 'none !important',
        borderColor: 'transparent !important',
    },
    '& .MuiButtonGroup-grouped:not(:first-of-type)': {
        borderLeft: 'none !important',
        marginLeft: '0 !important',
    },
    '&:hover button': {
        bgcolor: `${theme.palette.primary.dark} !important`
    }
});

export const viewDetailBoxStyle = {
    width: '54px', 
    height: '48px', 
    borderRadius: 1, 
    border: `1px solid ${common.borderColor}`, 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center'
};

export const treatmentNameStyle = (length) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    maxWidth: length ? '75%' : '100%',
    textAlign: 'center'
});

export const bookedWithBoxStyle = {
    width: '100%',
    cursor: 'pointer',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const depositAmountDisabledStyle = (isDisabled) => {
    if (isDisabled) return { pointerEvents: 'none', opacity: 0.5 };
    return {};
};

export const paymentChipStyle = {
    padding: '2px 6px 2px 2px',
    backgroundColor: 'rgba(0, 184, 217, 0.16)',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'info.dark',
    fontSize: '0.75rem',
    fontWeight: 500,
    height: 22,
};
export const paymentChipTypeStyle = {
    padding: '0',
    bgcolor: 'info.dark',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'common.white',
    fontSize: '10px',
    lineHeight: '18px',
    fontWeight: 700,
    mr: 0.5,
    width: '18px',
    minWidth: '18px',
    height: '18px'
};

export const centerAlign = { display: 'flex', alignItems: 'center' };

export const depositPaymentWrapperStyle = { ...centerAlign, justifyContent: 'flex-start', flexWrap: 'wrap', gap: '4px', width: 'calc(100% - 40px)', pr: '0 !important', maxHeight: '60px', overflowY: 'auto' };

export const gridToolbarColumnsButtonStyle = {
    width: '30px',
    overflow: 'hidden',
    minWidth: 'auto',
    justifyContent: 'flex-start',
};

export const clinCheckStatusStyle = ({ typed }) => ({
    px: 2,
    backgroundColor: 'rgba(84, 214, 44, 0.16)',
    color: common.meadowGreen,
    cursor: typed !== 'ArchiveTable' && 'pointer',
});

export const syncDentallyBtnStyle = {
    backgroundColor: '#078DEE !important',
    color: '#fff !important',
    boxShadow: '0px 4px 12px rgba(7, 141, 238, 0.3)',
    minWidth: '160px',
    borderRadius: 1,
    p: '6px 14px',
    fontSize: '0.8125rem',
    fontWeight: 600,
    '&:hover': {
        backgroundColor: '#0666B8 !important',
        boxShadow: '0px 6px 16px rgba(7, 141, 238, 0.4)',
    },
};